import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import * as project from "../common/api/projects";
import * as impact from '../common/api/impact';
import LandingPage from "./Pages/LandingPage";
import ImpactPage from "./Pages/ImpactPage";

function App() {
  const merchantCode = 'MYC_PW_SAPPHIRE_TRAVELLER';
  const [fetchedImpact, setfetchedImpact] = useState();
  const [projects, setProjects] = useState();

  useEffect(() => {
    impact.merchants(merchantCode, null) // fetch flight impact
      .then(response => response.json())
      .then(body => {
        setfetchedImpact(body)
      })
      .catch(error => {
        setfetchedImpact(error)
      })
  }, []);

  return (
    <>
      <Switch>
        <Route
          exact
          path={`/impact`}
          key="app-sapphire-impact">
            <ImpactPage merchantCode={merchantCode} />
          </Route>
        <Route
          path={`/`}
          key="app-sapphire-landing">
          <LandingPage fetchedImpact={fetchedImpact} merchantCode={merchantCode} />
        </Route>
      </Switch>
    </>
  );
}

export default App;
